// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/fractalgraphic-fullcolor-solid.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Proxima+Nova);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Commissioner:wght@100..900&family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Style rules used across the application */
/* Page-specific rules live in separate files */

/* Proxima Nova font */

/* Commissioner font */

/* Ensure that pages stretch the height of the window  */
html, body, #root, #root > * {
  min-height: 100dvh;
  margin: 0;
}

h1, h2, h3 {
  /* Use Proxima Nova for headers */
  font-family: "proxima-nova", sans-serif;
  font-weight: 800!important;
}

#root {
  height: 100dvh;
}

/* Use Commissioner for paragraph text */
p, h4, h5, h6 {
  font-family: "Commissioner", sans-serif;
}

/* CSS custom properties */
:root {
  /* FRACTAL brand palette colors */
  --yellow: #ffac30;
  --blue: #56becf;
  --light-purple: #ae5ec6;
  --pink: #b418ac;
  --dark-purple: #752a8b;
}

.yellow {
  background-color: var(--yellow)!important;
}

.blue {
  background-color: var(--blue)!important;
}

.light-purple {
  background-color: var(--light-purple)!important;
}

.pink {
  background-color: var(--pink)!important;
}

.dark-purple {
  background-color: var(--dark-purple)!important;
}

/* Text colors */

.white-text {
  color: white!important;
}

.black-text {
  color: black!important;
}

/* Used to indicate that user is currently visiting a page/child page
   listed in the topbar (i.e. Explore, Lessons, Admin) */
.active-page {
  background-color: var(--light-purple);
}

/* Applies standard background - light gray with FRACTAL triangle graphic */
.page {
  background-color: #f5f5f5;

  /* Background graphic */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: auto 70%;
  background-attachment: fixed;

  width: 100%;
}

/* Page that uses a splash screen during load */
.page-with-splash {
  background-color: #1A0022;
  width: 100%;
}

/* Disable highlight/select text */
.disallow-text-select {
  -webkit-user-select: none;
          user-select: none;
}

.center-text {
  text-align: center;
}

/* Navbar/Topbar */

#topbar {
  background-color: var(--dark-purple);
  color: white;

  padding-left: 1vw;
  padding-right: 1vw;

  display: flex;
  flex-direction: row;
  align-items: center;
}

#topbar-logo {
  height: 3vh;
  height: max(3vh, 20px);
}

#topbar * {
  color: white;
}

#topbar-links {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 100%;
}

#topbar-left-side {
  padding: 0;

  align-self: stretch;

  display: flex;
  flex-direction: row;
  gap: 10px;

  font-size: max(2.5vh, 15px);
}

#topbar-left-side > div {
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;

  font-family: "proxima-nova", sans-serif;
  font-weight: 800;
}

#topbar-left-side a {
  text-decoration: none;

  height: 100%;
  
  padding-left: 20px;
  padding-right: 20px;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

#topbar-left-side > div:hover {
  background-color: var(--light-purple);
}

#topbar-left-side > div:focus {
  background-color: var(--light-purple);
}

#topbar-avatar-link {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  display: inline-block;

  right: 10px;

  padding-top: 1vh;
  padding-bottom: 1vh;
}

#topbar-avatar * {
  font-size: max(2.25vh, 15px);
}

#topbar-dropdown-options {
  display: none;
  
  background-color: white;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);

  position: absolute;
  right: 0;

  margin: 0;
  margin-right: 10px!important;
  margin-top: 5px!important;

  /* Create rounded border */
  border-radius: 10px;

  /* When children are highlighted, clip background to rounded border */
  overflow: hidden;

  z-index: 10;
}

#topbar-dropdown-options > div {
  width: max(10vw, 100px);

  display: flex;
}

#topbar-dropdown-options > div:hover {
  background-color: #eeeeee;
}

#topbar-dropdown-options > div > a {
  text-decoration: none; /* Remove default link underline */
  color: black;

  width: 100%;
  height: 100%;

  padding: 10px;
  
  text-align: left;
  font-size: max(2.5vh, 15px);
}

#logout-option {
  border-style: solid none none none;
  border-width: 1px;
  border-color: #cccccc;
}

#logout-option:hover {
  cursor: pointer;
}

#topbar-right-side {
  margin: 0;
}

#topbar-right-side:hover #topbar-dropdown-options {
  display: flex;
  flex-direction: column;
}

/* Go Back Link - mini internal bar that allows players to navigate
   from child pages (ex: Algorithmic Art) to its parent (ex: Explore) */

#go-back-link {
  background-color: #430156;
  padding: 5px;
}

#go-back-link > a {
  color: white;
  text-decoration: none;
  text-align: left!important;
}

/* Popup styling */

#popup-container {
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(0, 0, 0, 0.5);

  position: fixed;
  z-index: 1;
  
  width: 100dvw;
  height: 100dvh;
}

#popup {
  background-color: white;

  width: 100%;

  border-radius: 25px;
  overflow: hidden;

  z-index: 5;
  margin: 10vh;
}

#popup-header {
  background-color: var(--dark-purple);
  color: white;

  display: flex;
  flex-direction: row;
  align-items: center;
}

#popup-header > * {
  padding: 15px;
}

#popup-title {
  flex-grow: 1;
}

#popuop-x-out {
  background-color: var(--light-purple);

  display: flex;
  justify-content: center;
  align-items: center;

  width: 5vw;
  
  font-size: 2.5vw;
}

#popup-x-out:hover {
  cursor: pointer;
}

#popup-content {
  height: 65vh;
  overflow-y: scroll;
}

/* Challenge popup styling */

.challenge {
  width: 100%;
  height: 20vh;

  border-style: solid;
  border-width: 2px;
  border-color: #cccccc;

  padding: 0;
  margin: 0;

  display: flex;
  flex-direction: row;
  gap: 35px;
  align-items: center;

  padding: 20px;
}

#challenge-icon {
  height: 60%;
  aspect-ratio: 1 / 1;
  border-radius: 100%;
  background-color: var(--light-purple);

  flex-grow: 1;
}

#challenge-meta {
  display: flex;
  flex-direction: column;
}

#challenge-progress {
  flex-grow: 1;
}

#challenge-progress > p {
  text-align: center;
  padding: 10px;
  margin: 0;
}

#challenge-progress-bar {
  background-color: #cccccc;
  height: 5vh;
  border-radius: 25px;
  width: 20vw;
  overflow: hidden;
}

#challenge-completed-bar {
  background-color: var(--blue);
  width: 50%;
  height: 100%;
}

/* Responsive styling */
@media screen and (max-width: 800px) {
  .page {
    background-size: auto 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C,+CAA+C;;AAE/C,sBAAsB;;AAGtB,sBAAsB;;AAGtB,wDAAwD;AACxD;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,uCAAuC;AACzC;;AAEA,0BAA0B;AAC1B;EACE,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;AAChD;;AAEA,gBAAgB;;AAEhB;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;wDACwD;AACxD;EACE,qCAAqC;AACvC;;AAEA,2EAA2E;AAC3E;EACE,yBAAyB;;EAEzB,uBAAuB;EACvB,yDAAkE;EAClE,4BAA4B;EAC5B,iCAAiC;EACjC,yBAAyB;EACzB,4BAA4B;;EAE5B,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;;AAElB;EACE,oCAAoC;EACpC,YAAY;;EAEZ,iBAAiB;EACjB,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;;EAEnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;;EAEV,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET,2BAA2B;AAC7B;;AAEA;EACE,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;;EAErB,YAAY;;EAEZ,kBAAkB;EAClB,mBAAmB;;EAEnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;;EAEzB,qBAAqB;;EAErB,WAAW;;EAEX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;;EAEb,uBAAuB;EACvB,4CAA4C;;EAE5C,kBAAkB;EAClB,QAAQ;;EAER,SAAS;EACT,4BAA4B;EAC5B,yBAAyB;;EAEzB,0BAA0B;EAC1B,mBAAmB;;EAEnB,qEAAqE;EACrE,gBAAgB;;EAEhB,WAAW;AACb;;AAEA;EACE,uBAAuB;;EAEvB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB,EAAE,kCAAkC;EACzD,YAAY;;EAEZ,WAAW;EACX,YAAY;;EAEZ,aAAa;;EAEb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;uEACuE;;AAEvE;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,oCAAoC;;EAEpC,eAAe;EACf,UAAU;;EAEV,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,uBAAuB;;EAEvB,WAAW;;EAEX,mBAAmB;EACnB,gBAAgB;;EAEhB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;;EAErC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,UAAU;;EAEV,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,4BAA4B;;AAE5B;EACE,WAAW;EACX,YAAY;;EAEZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;;EAErB,UAAU;EACV,SAAS;;EAET,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;;EAEnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;;EAErC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Style rules used across the application */\n/* Page-specific rules live in separate files */\n\n/* Proxima Nova font */\n@import url('https://fonts.googleapis.com/css?family=Proxima+Nova');\n\n/* Commissioner font */\n@import url('https://fonts.googleapis.com/css2?family=Commissioner:wght@100..900&family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap');\n\n/* Ensure that pages stretch the height of the window  */\nhtml, body, #root, #root > * {\n  min-height: 100dvh;\n  margin: 0;\n}\n\nh1, h2, h3 {\n  /* Use Proxima Nova for headers */\n  font-family: \"proxima-nova\", sans-serif;\n  font-weight: 800!important;\n}\n\n#root {\n  height: 100dvh;\n}\n\n/* Use Commissioner for paragraph text */\np, h4, h5, h6 {\n  font-family: \"Commissioner\", sans-serif;\n}\n\n/* CSS custom properties */\n:root {\n  /* FRACTAL brand palette colors */\n  --yellow: #ffac30;\n  --blue: #56becf;\n  --light-purple: #ae5ec6;\n  --pink: #b418ac;\n  --dark-purple: #752a8b;\n}\n\n.yellow {\n  background-color: var(--yellow)!important;\n}\n\n.blue {\n  background-color: var(--blue)!important;\n}\n\n.light-purple {\n  background-color: var(--light-purple)!important;\n}\n\n.pink {\n  background-color: var(--pink)!important;\n}\n\n.dark-purple {\n  background-color: var(--dark-purple)!important;\n}\n\n/* Text colors */\n\n.white-text {\n  color: white!important;\n}\n\n.black-text {\n  color: black!important;\n}\n\n/* Used to indicate that user is currently visiting a page/child page\n   listed in the topbar (i.e. Explore, Lessons, Admin) */\n.active-page {\n  background-color: var(--light-purple);\n}\n\n/* Applies standard background - light gray with FRACTAL triangle graphic */\n.page {\n  background-color: #f5f5f5;\n\n  /* Background graphic */\n  background-image: url(./images/fractalgraphic-fullcolor-solid.svg);\n  background-repeat: no-repeat;\n  background-position: right bottom;\n  background-size: auto 70%;\n  background-attachment: fixed;\n\n  width: 100%;\n}\n\n/* Page that uses a splash screen during load */\n.page-with-splash {\n  background-color: #1A0022;\n  width: 100%;\n}\n\n/* Disable highlight/select text */\n.disallow-text-select {\n  user-select: none;\n}\n\n.center-text {\n  text-align: center;\n}\n\n/* Navbar/Topbar */\n\n#topbar {\n  background-color: var(--dark-purple);\n  color: white;\n\n  padding-left: 1vw;\n  padding-right: 1vw;\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n#topbar-logo {\n  height: 3vh;\n  height: max(3vh, 20px);\n}\n\n#topbar * {\n  color: white;\n}\n\n#topbar-links {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  width: 100%;\n  height: 100%;\n}\n\n#topbar-left-side {\n  padding: 0;\n\n  align-self: stretch;\n\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n\n  font-size: max(2.5vh, 15px);\n}\n\n#topbar-left-side > div {\n  height: 100%;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  font-family: \"proxima-nova\", sans-serif;\n  font-weight: 800;\n}\n\n#topbar-left-side a {\n  text-decoration: none;\n\n  height: 100%;\n  \n  padding-left: 20px;\n  padding-right: 20px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n#topbar-left-side > div:hover {\n  background-color: var(--light-purple);\n}\n\n#topbar-left-side > div:focus {\n  background-color: var(--light-purple);\n}\n\n#topbar-avatar-link {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n\n  display: inline-block;\n\n  right: 10px;\n\n  padding-top: 1vh;\n  padding-bottom: 1vh;\n}\n\n#topbar-avatar * {\n  font-size: max(2.25vh, 15px);\n}\n\n#topbar-dropdown-options {\n  display: none;\n  \n  background-color: white;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n\n  position: absolute;\n  right: 0;\n\n  margin: 0;\n  margin-right: 10px!important;\n  margin-top: 5px!important;\n\n  /* Create rounded border */\n  border-radius: 10px;\n\n  /* When children are highlighted, clip background to rounded border */\n  overflow: hidden;\n\n  z-index: 10;\n}\n\n#topbar-dropdown-options > div {\n  width: max(10vw, 100px);\n\n  display: flex;\n}\n\n#topbar-dropdown-options > div:hover {\n  background-color: #eeeeee;\n}\n\n#topbar-dropdown-options > div > a {\n  text-decoration: none; /* Remove default link underline */\n  color: black;\n\n  width: 100%;\n  height: 100%;\n\n  padding: 10px;\n  \n  text-align: left;\n  font-size: max(2.5vh, 15px);\n}\n\n#logout-option {\n  border-style: solid none none none;\n  border-width: 1px;\n  border-color: #cccccc;\n}\n\n#logout-option:hover {\n  cursor: pointer;\n}\n\n#topbar-right-side {\n  margin: 0;\n}\n\n#topbar-right-side:hover #topbar-dropdown-options {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Go Back Link - mini internal bar that allows players to navigate\n   from child pages (ex: Algorithmic Art) to its parent (ex: Explore) */\n\n#go-back-link {\n  background-color: #430156;\n  padding: 5px;\n}\n\n#go-back-link > a {\n  color: white;\n  text-decoration: none;\n  text-align: left!important;\n}\n\n/* Popup styling */\n\n#popup-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background-color: rgba(0, 0, 0, 0.5);\n\n  position: fixed;\n  z-index: 1;\n  \n  width: 100dvw;\n  height: 100dvh;\n}\n\n#popup {\n  background-color: white;\n\n  width: 100%;\n\n  border-radius: 25px;\n  overflow: hidden;\n\n  z-index: 5;\n  margin: 10vh;\n}\n\n#popup-header {\n  background-color: var(--dark-purple);\n  color: white;\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n#popup-header > * {\n  padding: 15px;\n}\n\n#popup-title {\n  flex-grow: 1;\n}\n\n#popuop-x-out {\n  background-color: var(--light-purple);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 5vw;\n  \n  font-size: 2.5vw;\n}\n\n#popup-x-out:hover {\n  cursor: pointer;\n}\n\n#popup-content {\n  height: 65vh;\n  overflow-y: scroll;\n}\n\n/* Challenge popup styling */\n\n.challenge {\n  width: 100%;\n  height: 20vh;\n\n  border-style: solid;\n  border-width: 2px;\n  border-color: #cccccc;\n\n  padding: 0;\n  margin: 0;\n\n  display: flex;\n  flex-direction: row;\n  gap: 35px;\n  align-items: center;\n\n  padding: 20px;\n}\n\n#challenge-icon {\n  height: 60%;\n  aspect-ratio: 1 / 1;\n  border-radius: 100%;\n  background-color: var(--light-purple);\n\n  flex-grow: 1;\n}\n\n#challenge-meta {\n  display: flex;\n  flex-direction: column;\n}\n\n#challenge-progress {\n  flex-grow: 1;\n}\n\n#challenge-progress > p {\n  text-align: center;\n  padding: 10px;\n  margin: 0;\n}\n\n#challenge-progress-bar {\n  background-color: #cccccc;\n  height: 5vh;\n  border-radius: 25px;\n  width: 20vw;\n  overflow: hidden;\n}\n\n#challenge-completed-bar {\n  background-color: var(--blue);\n  width: 50%;\n  height: 100%;\n}\n\n/* Responsive styling */\n@media screen and (max-width: 800px) {\n  .page {\n    background-size: auto 50%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
